import React, { Fragment, useEffect, useState } from "react";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import { Checkbox, Col, Flex, Form, Row } from "antd";

import "@/styles/pages/profile/travel-details.scss";
import BackWithLabel from "@/components/common/BackWithLabel";
import { updateTravelHistory } from "@/services/users/updateTravelHistory";
import ButtonComponent from "@/components/button/Button";
import { getUserDetails } from "@/services/users/getUpdateTravelHistory";
import useTriggerNotification from "@/hooks/useTriggerNotification";
const TravelDetails = () => {
  const [form] = Form.useForm();
  const [selectedValue, setSelectedValue] = useState("");
  const [questionOne, setQuestionOne] = useState(false);
  const [questionTwo, setQuestionTwo] = useState(false);
  const { trigger, element } = useTriggerNotification();

  const handleCheckboxChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleQuestionOne = (e) => {
    setQuestionOne(e.target.value);
  };

  const handleQuestionTwo = (e) => {
    setQuestionTwo(e.target.value);
  };

  const handleSubmit = () => {
    updateTravelHistory({
      travelHistory: {
        appliedForPermission: questionOne,
      },
      immigrationHistory: {
        needVisa: !!selectedValue?.length,
        countries: selectedValue?.length ? [selectedValue] : [],
      },
      visaRejections: {
        appliedForPermission: questionTwo,
      },
    })
      .then((res) => {
        console.log(res);
        trigger({
          type: "success",
          message: "Travel Details updated successfully",
        });
      })

      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getUserDetails()
      .then((res) => {
        setQuestionOne(res?.travelHistory?.appliedForPermission);
        setQuestionTwo(res?.visaRejections?.appliedForPermission);
        setSelectedValue(
          res.immigrationHistory?.needVisa ? res.immigrationHistory?.countries[0] : ""
        );
      })
      .catch((error) => console.log(error));
  }, []);
  return (
    <Fragment>
      {element}
      <div className="travel-details-page">
        <Container>
          <CardComponent>
            <Row>
              <Col xxl={24}>
                <div className="heading">
                  <BackWithLabel label="Travel Details" path="/profile" />
                </div>
              </Col>
            </Row>
            <div className="questions">
              <Row gutter={[16, 16]} justify="start">
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <div className="advance-question">
                    <CardComponent>
                      <div className="heading body-b1">1. Travel History</div>
                      <div className="question body-b3">
                        Has this student applied for permission to remain in any if the following
                        countries in the past ten years?
                      </div>
                      <Form
                        name="register"
                        initialValues={{ remember: true }}
                        layout="vertical"
                        form={form}
                      >
                        <div className="anster-button">
                          <Row gutter={[16, 16]} justify="center">
                            <Col xl={12} md={24} sm={24} xs={24}>
                              <Form.Item>
                                <Checkbox
                                  value={true}
                                  checked={questionOne == true}
                                  onChange={handleQuestionOne}
                                >
                                  Yes
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col xl={12} md={24} sm={24} xs={24}>
                              <Form.Item>
                                <Checkbox
                                  value={false}
                                  checked={questionOne === false}
                                  onChange={handleQuestionOne}
                                >
                                  No
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </CardComponent>
                  </div>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <div className="advance-question">
                    <CardComponent>
                      <div className="heading body-b1">2. Immigration History</div>
                      <div className="question body-b3">
                        Does this student need a visa to stay in any if the following countries?
                        Please tick all that apply.
                      </div>
                      <Form
                        name="register"
                        initialValues={{ remember: true }}
                        layout="vertical"
                        form={form}
                      >
                        <div className="anster-button">
                          <Row gutter={[16, 16]} justify="center">
                            <Col xl={12} md={24} sm={24} xs={24}>
                              <Form.Item>
                                <Checkbox
                                  value="uk"
                                  checked={selectedValue === "uk"}
                                  onChange={handleCheckboxChange}
                                >
                                  United Kingdom
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col xl={12} md={24} sm={24} xs={24}>
                              <Form.Item>
                                <Checkbox
                                  value={false}
                                  checked={!selectedValue?.length}
                                  onChange={handleCheckboxChange}
                                >
                                  None
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </CardComponent>
                  </div>
                </Col>
                <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <div className="advance-question">
                    <CardComponent>
                      <div className="heading body-b1">3. Travel History</div>
                      <div className="question body-b3">
                        For any country has this student ever been refused permission to stay or
                        remain, refused asylum or deported?
                      </div>
                      <Form
                        name="register"
                        initialValues={{ remember: true }}
                        layout="vertical"
                        form={form}
                      >
                        <div className="anster-button">
                          <Row gutter={[16, 16]} justify="center">
                            <Col xl={12} md={24} sm={24} xs={24}>
                              <Form.Item>
                                <Checkbox
                                  value={true}
                                  checked={questionTwo === true}
                                  onChange={handleQuestionTwo}
                                >
                                  Yes
                                </Checkbox>
                              </Form.Item>
                            </Col>
                            <Col xl={12} md={24} sm={24} xs={24}>
                              <Form.Item>
                                <Checkbox
                                  value={false}
                                  checked={questionTwo === false}
                                  onChange={handleQuestionTwo}
                                >
                                  No
                                </Checkbox>
                              </Form.Item>
                            </Col>
                          </Row>
                        </div>
                      </Form>
                    </CardComponent>
                  </div>
                </Col>
              </Row>
              <Flex className="submit-button flex w-100" justify="center">
                <ButtonComponent label="Save Details" varient="primary" onClick={handleSubmit} />
              </Flex>
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default TravelDetails;
